import TitleBlock from '@anm/components/TitleBlock';
import { media } from '@anm/styles/helpers';
import styled from 'styled-components';

const titleOnMobile = media.phone`
  font-size: 26px;
  margin-bottom: 10px;
`;

export const Title = styled(TitleBlock)`
  h1,
  h2,
  h3,
  h4,
  h5 {
    font-size: 32px;
    font-weight: 700;
    ${titleOnMobile};
  }
`;

const gridWrapperOnMobile = media.phone`
  margin: 0;
`;

export const GridWrapper = styled.div`
  margin: 23px;
  ${gridWrapperOnMobile};
`;

const wrapperOnMobile = media.phone`
  margin: 0 20px;;
`;

const Wrapper = styled.div`
  margin: 40px;
  ${wrapperOnMobile};
`;

export default Wrapper;
